<template>
  <v-dialog v-model="modalAberto" persistent max-width="400">
    <div class="modal card-default position-relative">
      <div class="modal__header">
        <div class="d-flex align-center">
          <v-icon color="#fff" class="me-2">mdi-help-circle</v-icon>
          <h3 class="ma-0">Escolha a Plataforma de Avaliação</h3>
        </div>
        <v-btn @click="$emit('close')" class="ms-3" small fab color="#CE0000">
          <v-icon color="#fff">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="modal__content mt-4">
        <div class="avaliacao-choice">
          <div class="choice-buttons">
            <v-card
              class="choice-card card-default"
              @click="selectOption('evoluir')"
            >
              <div class="choice-content">
                <v-icon size="40" color="#fff">mdi-school</v-icon>
                <h5 class="mt-2 white--text">Evoluir</h5>
                <p class="mb-0 white--text text-center">Plataforma Evoluir</p>
              </div>
            </v-card>

            <v-card
              v-if="shouldShowMaxiaOption"
              class="choice-card card-default"
              @click="selectOption('maxia')"
              :disabled="loadingMaxiaUrl"
            >
              <div class="choice-content">
                <v-progress-circular
                  v-if="loadingMaxiaUrl"
                  indeterminate
                  color="white"
                  size="40"
                ></v-progress-circular>
                <v-icon v-else size="40" color="#fff">mdi-chart-line</v-icon>
                <h5 class="mt-2 white--text">Educar</h5>
                <p class="mb-0 white--text text-center">
                  {{ loadingMaxiaUrl ? 'Carregando...' : 'Plataforma Maxia' }}
                </p>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import educarMaxiaService from "@/utils/services/educarMaxiaService";
import alerts from "@/mixins/alerts";

export default {
  name: "ModalEscolhaAvaliacaoPlataforma",
  
  mixins: [alerts],
  
  props: {
    modalAberto: {
      type: Boolean,
      default: false
    },
    
    grupoEducarInfo: {
      type: Object,
      default: () => ({
        is_grupo_educar: false,
        demo: 0,
        id_escola: null
      })
    }
  },

  emits: ['close', 'select-evoluir', 'select-maxia', 'show-toast'],

  data() {
    return {
      loadingMaxiaUrl: false,
    };
  },

  computed: {
    shouldShowMaxiaOption() {
      return educarMaxiaService.shouldShowMaxiaOption(this.grupoEducarInfo);
    },
  },

  methods: {
    async selectOption(platform) {
      if (platform === 'maxia') {
        await this.handleMaxiaSelection();
      } else {
        this.$emit('select-evoluir', platform);
      }
      this.$emit('close');
    },

    async handleMaxiaSelection() {
      this.loadingMaxiaUrl = true;
      try {
        const result = await educarMaxiaService.fetchIntegracaoEducarMaxia();
        
        if (!result.success) {
          this.alertErro(
            { response: { data: { message: result.message } } },
            "Não foi possível acessar a plataforma Educar Maxia."
          );
          return;
        }
        
        this.$emit('show-toast', {
          type: 'info',
          message: 'Redirecionando para a plataforma Educar Maxia...',
          timeout: 5000
        });
        
        await new Promise(resolve => setTimeout(resolve, 4000));
        
        educarMaxiaService.redirectToMaxia(result.url);
        this.$emit('select-maxia', 'maxia', result.url);
      } catch (error) {
        this.alertErro(
          error,
          "Erro inesperado. Entre em contato com o gestor da escola."
        );
      } finally {
        this.loadingMaxiaUrl = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  background-color: #fff;
  padding-bottom: 30px;

  &__header {
    background: linear-gradient(var(--main-gradient));
    color: #fff;
    padding: 20px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: inherit;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.avaliacao-choice {
  padding: 20px;
  text-align: center;
}

.choice-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
}

.choice-card {
  background: linear-gradient(var(--main-gradient));
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;

  &:hover {
    filter: brightness(110%);
    transform: translateY(-2px);
  }

  .choice-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    h5 {
      margin: 8px 0 4px 0;
      font-weight: 600;
    }

    p {
      font-size: 0.85rem;
      opacity: 0.9;
    }
  }
}
</style> 